import React from 'react';

export type FirmenKategorie = 'einzelfirma' | 'mit_kontakten' | 'ohne_kontakt';

export const FIRMEN_KATEGORIE_LABELS: Record<FirmenKategorie, { label: string; short: string; bg: string; color: string }> = {
  mit_kontakten: { label: 'Firma mit Ansprechpartnern', short: 'Mit Kontakten', bg: '#e8f5e9', color: '#2e7d32' },
  einzelfirma:   { label: 'Einzelfirma',                short: 'Einzelfirma',    bg: '#e3f2fd', color: '#1565c0' },
  ohne_kontakt:  { label: 'Firma ohne Kontakt',         short: 'Ohne Kontakt',   bg: '#fff3e0', color: '#e65100' },
};

export function FirmenKategorieBadge({ kategorie, size = 'small' }: {
  kategorie?: FirmenKategorie | null;
  size?: 'small' | 'medium';
}) {
  if (!kategorie) return null;
  const meta = FIRMEN_KATEGORIE_LABELS[kategorie];
  if (!meta) return null;
  const padding = size === 'small' ? '1px 6px' : '3px 9px';
  const fontSize = size === 'small' ? '9px' : '11px';
  return (
    <span
      title={meta.label}
      style={{
        display: 'inline-block',
        padding,
        borderRadius: '10px',
        fontSize,
        fontWeight: 600,
        letterSpacing: '0.3px',
        background: meta.bg,
        color: meta.color,
        verticalAlign: 'middle',
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
      }}
    >
      {meta.short}
    </span>
  );
}
